import { render, staticRenderFns } from "./RetailListDetail.vue?vue&type=template&id=48bbd303&scoped=true"
import script from "./RetailListDetail.vue?vue&type=script&lang=js"
export * from "./RetailListDetail.vue?vue&type=script&lang=js"
import style0 from "./RetailListDetail.vue?vue&type=style&index=0&id=48bbd303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bbd303",
  null
  
)

export default component.exports